var metrikaId = 55586965;

function ymGoalFeedback() {
  ym(metrikaId, "reachGoal", "send-request");
}

// function yamaps_init(container_id) {
//   var $container = $("#" + container_id);

//   if ($container.length === 0 || $container.hasClass("ready")) {
//     return;
//   }

//   $container.addClass("ready");

//   ymaps.ready(function init() {
//     let myMap = new ymaps.Map(container_id, {
//       center: [55.857473, 37.65187],
//       zoom: 15.5,
//       controls: [],
//     });

//     myMap.geoObjects.add(
//       new ymaps.Placemark(
//         [55.857473, 37.65187],
//         {
//           balloonContent: "",
//           iconCaption: "улица Кольская, 1",
//         },
//         {
//           preset: "islands#redIcon",
//         }
//       )
//     );
//   });
// }

// function onYmReady(ymaps) {
//   $(".yamaps-auto").each(function () {
//     yamaps_init($(this).attr("id"));
//   });
// }
